module.exports = "<div class=\"container h-100 w-100\">\n  <div class=\"row h-100 w-100 align-items-center\">\n    <div class=\"col-md-12 text-center\">\n      <img src=\"/assets/img/logo-300x186.png\" alt=\"Sube Pagos\">\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main